import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  Panel,
  Row,
  Col,
} from 'react-bootstrap';
import { branch, compose, renderNothing } from 'recompose';

import exact from 'prop-types-exact';

import getCachedObjectId from '../../../utils/getCachedObjectId';

import './TimesheetOverview.css';

const propTypes = exact({
  userTimesheet: PropTypes.object.isRequired,

  /* eslint-disable react/no-unused-prop-types */
  /* Query variable props */
  userId: PropTypes.number.isRequired,
  originDate: PropTypes.string.isRequired,
  /* eslint-enable react/no-unused-prop-types */
});

const TimesheetOverview = (props) => {
  const { userTimesheet } = props;

  const weeklyDetails = userTimesheet;
  const dailyHours = weeklyDetails.daily_time_entries;

  return (
    <div>
      <Panel header="Overview">
        <Row>
          <Col md={3}>
            <h3>
              {userTimesheet.user.firstname} {userTimesheet.user.lastname}
            </h3>
            <h4>
              Week of: {userTimesheet.start_date.display}
            </h4>
          </Col>
          <Col md={8}>
            <Table
              className="col-md-4 col-sm-6 col-xs-8 timesheetSummaryOverview-overview-table"
            >
              <thead>
                <tr>
                  {dailyHours.map((item, index) => {
                    const cacheId = getCachedObjectId(item);
                    return (
                      <th key={cacheId}> {item.date.day_of_week} </th>
                    );
                  })}
                  <th>Total Hours</th>
                  <th>Out Of Service</th>
                  <th>Overtime Hours</th>
                  <th>PTO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {dailyHours.map((item) => {
                    const cacheId = getCachedObjectId(item);
                    return (
                      <td key={cacheId}> {item.total_hours.to_string} </td>
                    );
                  })}
                  <td>{weeklyDetails.total_hours.to_string}</td>
                  <td>{weeklyDetails.out_of_service.to_string}</td>
                  <td>{weeklyDetails.overtime.to_string}</td>
                  <td>{weeklyDetails.pto.to_string}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </Panel>
    </div>
  );
};

TimesheetOverview.propTypes = propTypes;

const withHide = branch(
  (props) => { return !props.userTimesheet; },
  renderNothing,
);

const enhance = compose(withHide);

export default enhance(TimesheetOverview);
